import {
  disableScrolling,
  enableScrolling,
} from './utils';

/** DOM reference */
const accountDrawer = document.getElementById('js-account-drawer');

/** Internal state (safe defaults) */
let lastFocusedElement: HTMLElement | null = null;

/**
 * Initialize ONLY if account drawer exists
 */
if (accountDrawer) {
  initAccountDrawer(accountDrawer);
}

/**
 * Init logic (runs once per page)
 */
function initAccountDrawer(drawer: HTMLElement) {
  const closeBtns = drawer.querySelectorAll('.js-close-btn');
  const drawerToggles = document.querySelectorAll('.js-toggle-account-drawer');
  const drawerOverlay = drawer.querySelector('.account-drawer__overlay');

  drawerToggles.forEach((btn) => btn.addEventListener('click', openAccountDrawer));
  closeBtns.forEach((btn) => btn.addEventListener('click', closeAccountDrawer));
  drawerOverlay?.addEventListener('click', closeAccountDrawer);

  document.addEventListener('keyup', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('open')) {
      e.preventDefault();
      closeAccountDrawer();
    }
  });
}

/**
 * Open account drawer
 */
export function openAccountDrawer() {
  if (!accountDrawer) {
    return;
  }

  lastFocusedElement = document.activeElement as HTMLElement;

  accountDrawer.classList.add('open');
  accountDrawer.removeAttribute('aria-hidden');
  accountDrawer.removeAttribute('inert');
  disableScrolling();

  // document.dispatchEvent(new Event('account-drawer:opened'));

  accountDrawer.focus({ preventScroll: true });
}

/**
 * Close account drawer
 */
export async function closeAccountDrawer() {
  if (!accountDrawer) {
    return;
  }

  accountDrawer.classList.remove('open');
  accountDrawer.setAttribute('inert', '');
  accountDrawer.setAttribute('aria-hidden', 'true');
  enableScrolling();

  const pageBtns = document.querySelectorAll<HTMLElement>(`
    select[data-tabindex="modified"],
    input[data-tabindex="modified"],
    textarea[data-tabindex="modified"],
    button[data-tabindex="modified"],
    a[data-tabindex="modified"],
    iframe[data-tabindex="modified"]
  `);

  pageBtns.forEach((btn) => {
    btn.setAttribute('tabindex', '0');
    btn.removeAttribute('data-tabindex');
  });

  const tabbables = accountDrawer.querySelectorAll<HTMLElement>('[data-tabindex="modified"]');
  tabbables.forEach((el) => {
    el.setAttribute('tabindex', '-1');
    el.removeAttribute('data-tabindex');
  });

  if (lastFocusedElement) {
    lastFocusedElement.focus({ preventScroll: true });
    lastFocusedElement = null;
  }
}
